The formatted representation of the whole address for display purposes.

This field has a maximum length of 1,000 characters.
